import { Pipe, PipeTransform } from '@angular/core';
import { formatChileanNumber } from '../utils/numeros.util';

/**
 * Pipe para formatear números en templates HTML siguiendo el estándar chileno.
 * Uso: {{ valor | chileanNumber:2 }}
 */
@Pipe({
  name: 'chileanNumber',
  standalone: false
})
export class ChileanNumberPipe implements PipeTransform {
  transform(value: number | string | undefined | null, decimals: number = 0): string {
    return formatChileanNumber(value, decimals);
  }
}
